var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"main-menu",attrs:{"id":"side-menu"}},[_c('ul',{staticClass:"menu__items"},_vm._l((_vm.availableMenuItems),function(menuItem){return _c('main-menu-item',_vm._b({key:menuItem.id},'main-menu-item',menuItem,false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }